
import {Component, Prop, Vue} from "vue-property-decorator";
import AuditTrailTable from "@/components/audittrail/AuditTrailTable.vue";
import {auditTrailModule, currentUserModule, instrumentModule, studyPatientModule, visitModule} from "@/store";
import {translate} from "@/auxillary/translation";
import {formatDateTime} from "@/auxillary/date-format";

@Component({
  components: {AuditTrailTable}
})
export default class InstrumentAuditTrailView extends Vue {
  @Prop({default: ""}) private patientId: string;
  @Prop({default: ""}) private visitId: string | undefined;
  @Prop({default: ""}) private instrumentId: string;

  get studyPatientAlias() {
    return studyPatientModule.studyPatient?.displayName ?? "";
  }

  get visitDisplayName() {
    return instrumentModule?.instrument?.visitId ? translate(visitModule?.visit?.displayKey ?? "") : "";
  }

  get instrumentDisplayName() {
    return translate(instrumentModule?.instrument?.displayKey ?? "");
  }

  get currentUserDetails() {
    return (currentUserModule.user?.userName ?? "") + " (" + (currentUserModule.roleIdentifier ?? "") + ") " + formatDateTime((new Date().toUTCString()))
  }

  get changes() {
    return auditTrailModule.auditChanges ?? [];
  }

  async mounted() {
    await currentUserModule.loadIfEmpty();
    await studyPatientModule.loadById(this.patientId);
    await instrumentModule.loadById(this.instrumentId);
    if (this.visitId)
      await visitModule.loadById(this.visitId);
    await auditTrailModule.loadForInstrument(this.instrumentId)
  }

  async back() {
    if (this.visitId) {
      await this.$router.push({
        name: "visitinstrumentedit",
        params: {
          patientId: this.patientId,
          visitId: this.visitId,
          instrumentId: this.instrumentId
        }
      })
    } else {
      await this.$router.push({
        name: "standaloneinstrumentedit",
        params: {
          patientId: this.patientId,
          instrumentId: this.instrumentId
        }
      })
    }
  }
}
